// import React, { useState, useRef, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./ActionDropdown.css"; // ⬅️ Import external CSS

// export interface DropdownOption {
//   label: string;
//   icon?: React.ReactNode;
//   to?: string;
//   click?: any;
//   onClick?: () => void;
// }

// interface ActionDropdownProps {
//   options: DropdownOption[];
//   PropMinWidth: string
// }

// const ActionDropdown: React.FC<ActionDropdownProps> = ({ options, PropMinWidth = "240px" }) => {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   const toggleDropdown = () => setOpen((prev) => !prev);

//   const handleClickOutside = (event: MouseEvent) => {
//     if (
//       dropdownRef.current &&
//       !dropdownRef.current.contains(event.target as Node)
//     ) {
//       setOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="action-dropdown-wrapper" ref={dropdownRef}>
//       <span
//         className="action-dropdown-button"
//         onClick={toggleDropdown}
//         aria-expanded={open}
//       >
//         <i className="bi bi-three-dots-vertical action-dropdown-icon"></i>
//       </span>

//       {open && (
//         <ul className="action-dropdown-menu" style={{ minWidth: `${PropMinWidth}` }}>
//           {options.map((option, index) => (
//             <li
//               key={index}
//               className="action-dropdown-item"
//               onClick={() => {
//                 if (option.onClick) option.onClick();
//                 setOpen(false);
//               }}
//             >
//               {option.to ? (
//                 <Link to={option?.to} className="action-dropdown-link">
//                   {option.icon}
//                   {option.label}
//                 </Link>
//               ) : option?.click ?
//               (<span onClick={option?.click} className="action-dropdown-link cursor-pointer">
//                 {option.icon}
//                 {option.label}
//               </span>) : (
//                 <span className="action-dropdown-link">
//                   {option.icon}
//                   {option.label}
//                 </span>
//               )}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default ActionDropdown;

import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ActionDropdown.css";

export interface DropdownOption {
  label: string;
  icon?: React.ReactNode;
  to?: string;
  click?: () => void;
  onClick?: () => void;
  state?: any;
}

interface ActionDropdownProps {
  options: DropdownOption[];
  /** CSS width value (default "240px") */
  PropMinWidth?: string;
  /** Row index (optional).  If omitted, menu always opens downward. */
  rowIndex?: number;
}

const OFFSET_BY_INDEX: Record<number, string> = {
  0: "-25px",
  1: "-50px",
  2: "-50px",
  3: "-50px",
  4: "-50px",
  5: "-50px",
  6: "-50px",
  7: "-60px",
  8: "-60px",
  9: "-60px",
  10: "-60px",
  // 10: "-60px", ...
};

const ActionDropdown: React.FC<ActionDropdownProps> = ({
  options,
  rowIndex,
  PropMinWidth = "240px",
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  /* toggle + outside‑click */
  const toggle = () => setOpen((p) => !p);
  useEffect(() => {
    const close = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node))
        setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  /* figure out top value */
  const topValue =
    rowIndex !== undefined && OFFSET_BY_INDEX[rowIndex]
      ? OFFSET_BY_INDEX[rowIndex]
      : "100%"; // default is open downward

  return (
    <div className="action-dropdown-wrapper" ref={wrapperRef}>
      <span
        className="action-dropdown-button"
        onClick={toggle}
        aria-expanded={open}
      >
        <i className="bi bi-three-dots-vertical action-dropdown-icon" />
      </span>

      {open && (
        <ul
          className="action-dropdown-menu"
          style={{ minWidth: PropMinWidth, top: topValue, zIndex: 200000 }}
        >
          {options.map((opt, idx) => (
            <li
              key={idx}
              className="action-dropdown-item"
              onClick={() => {
                opt.onClick?.();
                opt.click?.();
                setOpen(false);
              }}
            >
              {opt.to ? (
                <Link to={opt.to} className="action-dropdown-link">
                  {opt.icon}
                  {opt.label}
                </Link>
              ) : (
                <span className="action-dropdown-link">
                  {opt.icon}
                  {opt.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActionDropdown;
